/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiAlertRfiConfig
 */
export interface InternalApiAlertRfiConfig {
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiAlertRfiConfig
     */
    isAlertReScreeningEnabled: boolean;
}

/**
 * Check if a given object implements the InternalApiAlertRfiConfig interface.
 */
export function instanceOfInternalApiAlertRfiConfig(value: object): value is InternalApiAlertRfiConfig {
    if (!('isAlertReScreeningEnabled' in value) || value['isAlertReScreeningEnabled'] === undefined) return false;
    return true;
}

export function InternalApiAlertRfiConfigFromJSON(json: any): InternalApiAlertRfiConfig {
    return InternalApiAlertRfiConfigFromJSONTyped(json, false);
}

export function InternalApiAlertRfiConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertRfiConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'isAlertReScreeningEnabled': json['isAlertReScreeningEnabled'],
    };
}

export function InternalApiAlertRfiConfigToJSON(json: any): InternalApiAlertRfiConfig {
    return InternalApiAlertRfiConfigToJSONTyped(json, false);
}

export function InternalApiAlertRfiConfigToJSONTyped(value?: InternalApiAlertRfiConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isAlertReScreeningEnabled': value['isAlertReScreeningEnabled'],
    };
}

